import {Component, Inject, ViewEncapsulation} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Watchlist } from 'src/app/models/watchlist';

@Component({
  selector: 'app-add-to-watchlist-confirmation-dialog',
  templateUrl: './add-to-watchlist-confirmation-dialog.component.html',
  styleUrls: ['./add-to-watchlists-confirmation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddToWatchlistConfirmationDialogComponent {
  loading = false;
  watchlist: Watchlist;

  addToWatchlist: (
    watchlistId: number,
    setLoading: (isLoading: boolean) => void
  ) => void;

  constructor(
    private dialogRef: MatDialogRef<AddToWatchlistConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { isin: string, watchlists: Watchlist[] },
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    if (this.watchlist) {
      this.addToWatchlist(this.watchlist.id, this.setLoading);
    }
  }

  private setLoading = (isLoading: boolean): void => {
    this.loading = isLoading;
  }
}
